<!--
Author: Lsc
Date: 2019-08-03
Desc: 绑定/解绑微信，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-wx-bind-change bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/info' }">个人中心</el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <el-row class="bind-wx">
            <el-col :span="22">
                <i class="fa fa-comments" aria-hidden="true"></i>
                &nbsp;绑定微信账号&emsp;
                <span class="bind-status" :style="{ color: bindflag ? 'green' : 'red' }">
                    {{ bindflag ? "已绑定" : "未绑定" }}
                </span>
            </el-col>
            <el-col :span="2">
                <el-button
                    :type="bindflag ? 'danger' : 'primary'"
                    size="mini"
                    v-on:click="bindOrUnbind"
                >
                    {{ bindflag ? "解绑" : "绑定" }}
                </el-button>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";

export default {
    name: "WxBindChange",
    mixins: [mixin],
    data() {
        return {
            bindflag: "",
            wxBindParam: {}
        };
    },
    created() {
        const info = this.$cache.getUser();
        this.bindflag = !!info.wxopenid;
        this.getUrlParam();
    },
    methods: {
        bindOrUnbind() {
            const _this = this;
            if (this.bindflag) {
                // 解绑
                this.$util.request("oauth/wechat", {}, "DELETE").then((res) => {
                    if (res.data) {
                        const info = _this.$cache.getUser();
                        let _x = Object.assign(info, { wxopenid: "" });
                        _this.$store.dispatch("setInfo", _x).then(() => {
                            _this.$message({
                                type: "success",
                                message: "微信解绑成功",
                                onClose: function () {}
                            });
                        });
                        _this.bindflag = false;
                    }
                });
            } else {
                this.bindWX();
            }
        },
        bindWX() {
            let backurl = encodeURIComponent(window.location.href + "/");
            let appid = this.$cache.getCompanyInfo().wechat_web_appid || "";
            window.location.href =
                "https://open.weixin.qq.com/connect/qrconnect?appid=" +
                this.$cache.getCompanyInfo().wechat_web_appid +
                "&redirect_uri=" +
                backurl +
                "&response_type=code&scope=snsapi_login&state=" +
                this.$cache.getSessionToken() +
                "#wechat_redirect";
        },
        // 获取URL查询参数
        getUrlParam() {
            var queryStr = location.href;
            var targetUrl = queryStr.substr(queryStr.indexOf("?") + 1).split("&");
            targetUrl.forEach((f) => {
                this.$set(this.wxBindParam, f.split("=")[0], f.split("=")[1]);
            });
            if (this.wxBindParam.code) this.wxrefresh();
        },
        // wx是否绑定，是否直接微信登录
        wxrefresh() {
            const _this = this;
            this.$util
                .request("oauth/wechat", this.wxBindParam, "PUT")
                .then((res) => {
                    // 绑定状态
                    if (res.data) {
                        const info = _this.$cache.getUser();
                        let _x = Object.assign(info, { wxopenid: res.data[0].oauthid });
                        _this.$store.dispatch("setInfo", _x).then(() => {
                            _this.$message({
                                type: "success",
                                message: "微信绑定成功",
                                onClose: function () {}
                            });
                        });
                        _this.bindflag = true;
                    }
                })
                .catch(() => {
                    _this.refresh();
                });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
/*用户信息 */
.bizcomp-wx-bind-change {
    padding-bottom: 50px;
    .bind-wx {
        margin: 20px;
        padding: 20px;
        border: 1px solid #ebebeb;
        border-radius: 3px;
        transition: 0.2s;
        font: {
            size: 18px;
        }
        &:hover {
            box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
        }
        .bind-status {
            font: {
                size: 14px;
            }
        }
    }
}
</style>
